import React from 'react';
import { ReactRelayContext } from 'react-relay';

// TODO: make this a hook so consumers do not need to pass context

import { getSelector } from 'relay-runtime'; // To fix mask issue. See usage below

export const unmaskFragmentData = ({ relayContext, relayData, fragmentPropName, fragment }) => {
    let fragmentFunc = fragment[fragmentPropName];
    if (typeof fragmentFunc === 'object') {
        fragmentFunc = fragmentFunc.modern;
    }
    const { selector } = getSelector(relayContext.variables, fragmentFunc(), relayData);
    return relayContext.environment.lookup(selector).data;
};

export function injectRelayContext(Component) {
    return function InjectRelayComponent(props) {
        return (
            <ReactRelayContext.Consumer>
                {relayContext => <Component {...props} relayContext={relayContext} />}
            </ReactRelayContext.Consumer>
        );
    };
}
